import { ProposalStatusStep } from '@/types/management.types'
import React from 'react'
interface ProposalStatusProps {
  onCloseSession?: () => void
  steps?: ProposalStatusStep[]
}

const ProposalStatus: React.FC<ProposalStatusProps> = ({
  onCloseSession,
  steps = [
    {
      id: 'authorization',
      title: 'Autorización',
      description: 'Hemos recibido y aprobado tu solicitud de arrendamiento.',
      status: 'completed',
    },
    {
      id: 'initial-payment',
      title: 'Pago inicial',
      description: 'Registramos el pago inicial.',
      status: 'completed',
    },
    {
      id: 'contract',
      title: 'Contrato',
      description:
        'Estamos preparando tu contrato. Pronto te contactaremos para la firma.',
      status: 'current',
    },
    {
      id: 'vehicle-management',
      title: 'Gestoría vehicular',
      description:
        'Estamos realizando el trámite de placas, tarjeta de circulación y otros documentos.',
      status: 'pending',
    },
    {
      id: 'vehicle-delivery',
      title: 'Entrega de vehículo',
      description:
        'Tu vehículo ya está listo. Nos pondremos en contacto para agendar la entrega.',
      status: 'pending',
    },
  ],
}) => {
  const getStepIcon = (status: string) => {
    switch (status) {
      case 'completed':
        return (
          <div className="w-8 h-8 bg-olr-primary rounded-full flex items-center justify-center">
            <svg
              className="w-5 h-5 text-white"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        )
      case 'current':
        return (
          <div className="w-8 h-8 rounded-full bg-gradient-radial from-white to-olr-primary"></div>
        )
      case 'pending':
      default:
        return <div className="w-8 h-8 bg-[#D0D5DD] rounded-full"></div>
    }
  }

  const getConnectorColor = (
    currentIndex: number,
    steps: ProposalStatusStep[]
  ) => {
    if (currentIndex === steps.length - 1) return 'bg-transparent'
    if (steps[currentIndex].status === 'completed') return 'bg-olr-primary'
    if (steps[currentIndex].status === 'current') return 'bg-gray-300'
    return 'bg-gray-300'
  }

  return (
    <div className="flex items-center justify-center p-5 bg-transparent">
      <div className="max-w-2xl w-full bg-transparent rounded-xl px-10 py-5">
        <div className="text-center mb-8">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            Estado de tu proceso
          </h1>
          <p className="text-lg text-gray-800">
            Revisa aquí el estado de tu proceso y conoce los próximos pasos.
          </p>
        </div>

        <div className="space-y-8 mb-10">
          {steps.map((step, index) => (
            <div key={step.id} className="relative flex items-start">
              {/* Step Icon */}
              <div className="flex-shrink-0 relative z-10">
                {getStepIcon(step.status)}
              </div>

              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div
                  className={`absolute left-4 top-8 w-0.5 h-28 ${getConnectorColor(index, steps)} -translate-x-1/2`}
                ></div>
              )}

              {/* Step Content */}
              <div className="ml-6 flex-1">
                <h3 className="text-xl font-semibold text-gray-800 mb-2">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button
            className="bg-transparent hover:bg-blue-50 text-blue-600 border-2 border-blue-600 
                       hover:border-blue-700 rounded-full px-10 py-3 text-lg font-medium 
                       transition-all duration-300 ease-in-out  
                       active:translate-y-0 min-w-[200px]"
            onClick={onCloseSession}
          >
            Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  )
}

export default ProposalStatus
